/*
 * Copyright (c) 2017 Datarista, Inc.
 */

/* eslint-disable consistent-return */

import { polyfill } from 'es6-promise';
import { push } from 'react-router-redux';
import { startAction, completeAction, handleError, reportSuccess } from './common';
import { accountServiceClient } from '../utils/api';

import { FIELDSET_TYPE_SKU, NEW_GROUP_PAGE, NEW_SKU_PAGE } from '../config/app_config';

polyfill();

export const actionTypes = {
  CHECK_ALL_DRAG_TABLE_ROW_STATE: 'CHECK_ALL_DRAG_TABLE_ROW_STATE',
  CHECK_ALL_DROP_TABLE_ROW_STATE: 'CHECK_ALL_DROP_TABLE_ROW_STATE',
  CLEAR_FIELDS_FOR_SKU: 'CLEAR_FIELDS_FOR_SKU',
  CREATE_DATASET_SUCCESS: 'CREATE_DATASET_SUCCESS',
  DATASETS_FETCH_SUCCESS: 'DATA_DATASETS_FETCH_SUCCES',
  DELETE_SKU: 'DELETE_SKU',
  ENABLE_VERSION: 'ENABLE_VERSION',
  FETCH_DATASETS_SUCCESS: 'FETCH_DATASETS_SUCCESS',
  FETCH_FILESET_PREVIEW: 'FETCH_FILESET_PREVIEW',
  FETCH_FILESET_SUCCESS: 'FETCH_FILESET_SUCCESS',
  FETCH_GROUP_FIELDS_SUCCESS: 'FETCH_GROUP_FIELDS_SUCCESS',
  FETCH_SINGLE_DATASET_SUCCESS: 'FETCH_SINGLE_DATASET_SUCCESS',
  FETCH_VERSIONS: 'FETCH_VERSIONS',
  FIELD_LIST_SUCCESS: 'FIELD_LIST_SUCCESS',
  FIELD_SYNC_SUCCESS: 'FIELD_SYNC_SUCCESS',
  FIELDSETS_FETCH_SUCCESS: 'DATA_FIELDSETS_FETCH_SUCCES',
  FTP_CREDENTIALS_FETCH_SUCCESS: 'FTP_CREDENTIALS_FETCH_SUCCESS',
  GET_FIELDS_FOR_SKU: 'GET_FIELDS_FOR_SKU',
  LAYOUTS_FETCH_BY_ID_SUCCESS: 'DATA_LAYOUTS_FETCH_BY_ID_SUCCESS',
  LIST_ALL_ACCOUNTS_SUCCESS: 'LIST_ALL_ACCOUNTS_SUCCESS',
  NEW_SKU_SUCCESS: 'NEW_SKU_SUCCESS',
  NEXT_PAGE: 'NEXT_PAGE',
  OPEN_CONFIG_FORM: 'OPEN_CONFIG_FORM',
  OPEN_EDIT_LIST: 'OPEN_EDIT_LIST',
  OPEN_EDIT_SKU: 'OPEN_EDIT_SKU',
  OPEN_FILESET_PREVIEW: 'OPEN_FILESET_PREVIEW',
  OPEN_GROUP_CREATION: 'OPEN_GROUP_CREATION',
  OPEN_SKU_CREATION: 'OPEN_SKU_CREATION',
  RESET_NEW_LIST_BOOLEANS: 'RESET_NEW_LIST_BOOLEANS',
  SET_CURRENT_DATASET: 'SET_CURRENT_DATASET',
  TOTAL_RECORDS_SUCCESS: 'TOTAL_RECORDS_SUCCESS',
  UPDATE_DRAG_TABLE_CHECKED: 'UPDATE_DRAG_TABLE_CHECKED',
  UPDATE_DRAG_TABLE_COMPLETE: 'UPDATE_DRAG_TABLE_COMPLETE',
  UPDATE_DRAG_TABLE_ROW_STATE: 'UPDATE_DRAG_TABLE_ROW_STATE',
  UPDATE_DROP_TABLE_CHECKED: 'UPDATE_DROP_TABLE_CHECKED',
  UPDATE_DROP_TABLE_COMPLETE: 'UPDATE_DROP_TABLE_COMPLETE',
  UPDATE_DROP_TABLE_ROW_STATE: 'UPDATE_DROP_TABLE_ROW_STATE',
};

// Connect to the API
const swaggerApi = accountServiceClient();

// pairs number of records with a datasetId
const totalRecordsSuccess = (datasetId, recordsInfo) => ({
  type: actionTypes.TOTAL_RECORDS_SUCCESS,
  datasetId,
  recordsInfo,
});

// Retrieves the total number of records associated
// with a given dataset
export function fetchDatasetRecordCount(datasetId, version, token) {
  const actionText = 'Fetching Dataset Versions';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFileSetCounts({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          version,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const recordsInfo = response.obj;
            dispatch(totalRecordsSuccess(datasetId, recordsInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const fetchVersionsSuccess = (datasetId, versions) => ({
  type: actionTypes.FETCH_VERSIONS,
  datasetId,
  versions,
});

// Fetches versions associated with a dataset
export function fetchVersions(datasetId, token) {
  const actionText = 'Fetching Dataset Versions';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getDataSetVersions({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const versionsInfo = response.obj;
            dispatch(fetchVersionsSuccess(datasetId, versionsInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - Fetch All Datasets Success
const dataSetsFetchSuccess = (dataSets, accountId) => ({
  type: actionTypes.DATASETS_FETCH_SUCCESS,
  dataSets,
  accountId,
});

// GET Datasets by Account ID
export function fetchDatasetsById(id, token) {
  const actionText = 'Fetching DataSets';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .listDataSets({
          Authorization: `bearer ${token}`,
          account_id: id,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const dataSetsInfo = response.obj;
            dispatch(dataSetsFetchSuccess(dataSetsInfo, id));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - Fetch Single Dataset Success
const singleDatasetFetchSuccess = (dataset, datasetId) => ({
  type: actionTypes.FETCH_SINGLE_DATASET_SUCCESS,
  dataset,
  datasetId,
});

// GET single dataset by dataset ID
export function fetchSingleDatasetById(datasetId, token) {
  const actionText = 'Fetching Single Dataset';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getDataSet({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const datasetInfo = response.obj;
            dispatch(singleDatasetFetchSuccess(datasetInfo, datasetId));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - Fetch All fieldsets Success
const fieldSetsFetchSuccess = (fieldSets, dataSetId) => ({
  type: actionTypes.FIELDSETS_FETCH_SUCCESS,
  fieldSets,
  dataSetId,
});

// GET fieldsets by dataset id
export function fetchFieldsetsById(dataSetId, fieldSetType, token) {
  const actionText = 'Fetching FieldSets';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFieldSets({
          Authorization: `bearer ${token}`,
          dataset_id: dataSetId,
          type: fieldSetType,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const fieldSetsInfo = response.obj;
            dispatch(fieldSetsFetchSuccess(fieldSetsInfo, dataSetId));
            completeAction(dispatch, actionText);
            // Possible TODO: make a call to determine fieldSetSize
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - Fetch All fieldsets Success
const ftpCredentialsFetchSuccess = ftpCredentials => ({
  type: actionTypes.FTP_CREDENTIALS_FETCH_SUCCESS,
  ftpCredentials,
});

// Get FTP Credectials by Account Id
export function fetchFTPCredentials(accountId, token) {
  const actionText = 'fetching ftp credentials';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.accounts
        .listFTPCredentials({
          Authorization: `bearer ${token}`,
          account_id: accountId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const ftpCredentials = response.obj;
            dispatch(ftpCredentialsFetchSuccess(ftpCredentials));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          // If no ftp info it will come through as an error. Not great but we'll handle it.
          if (err.status === 404) {
            const ftpCredentials = false;
            dispatch(ftpCredentialsFetchSuccess(ftpCredentials));
            completeAction(dispatch, actionText);
          } else {
            handleError(err, dispatch, actionText);
          }
        });
    });
  };
}

// Action - Fetch All Layouts Success
const layoutsFetchSuccess = layouts => ({
  type: actionTypes.LAYOUTS_FETCH_BY_ID_SUCCESS,
  layouts,
});

// GET Layouts by DataSet ID
export function fetchLayoutsById(id, token) {
  const actionText = 'Fetching Layouts';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .listLayout({
          Authorization: `bearer ${token}`,
          dataset_id: id,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const layoutsInfo = response.obj;
            // TODO: add another then block that grabs the field set sizes
            dispatch(layoutsFetchSuccess(layoutsInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action -- Create new dataset
const makeDatasetSuccess = (datasetInfo, currPage) => ({
  type: actionTypes.CREATE_DATASET_SUCCESS,
  datasetInfo,
  currPage,
});

// POST a new list
export function createList(token, listInfo, accountID, currPage, isAdmin) {
  const actionText = 'Creating new List (dataset)';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .createDataSet({
          Authorization: `bearer ${token}`,
          body: {
            accountId: accountID,
            name: listInfo.datasetName,
            listType: 'B2B',
            listGeo: 'US',
            status: 0,
          },
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const datasetInfo = response.obj;
            dispatch(makeDatasetSuccess(datasetInfo, currPage));
            completeAction(dispatch, actionText);
            if (isAdmin) {
              dispatch(push('/superadmin/listsummary'));
            } else {
              dispatch(push('/data'));
            }
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - Create FieldList
const fieldListSuccess = fields => ({
  type: actionTypes.FIELD_LIST_SUCCESS,
  fields,
});

// GET fields by dataset ID
export function listFields(datasetId, token) {
  const actionText = 'Listing Fields for SKU creation';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFieldsForDataSet({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const fieldInfo = response.obj;
            dispatch(fieldListSuccess(fieldInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Action - progress to next page in list/SKU creation
const nextPageSuccess = currPage => ({
  type: actionTypes.NEXT_PAGE,
  currPage,
});

export function nextPage(currPage) {
  const actionText = 'Progressing to next page';

  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(nextPageSuccess(currPage));
    completeAction(dispatch, actionText);
  };
}

// Action - go back to /data after list/SKU creation is complete
export function resetPage() {
  const actionText = 'Progressing to next page';

  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(nextPageSuccess(0));
    completeAction(dispatch, actionText);
    dispatch(push('/data'));
  };
}

const resetBooleans = () => ({
  type: actionTypes.RESET_NEW_LIST_BOOLEANS,
});

export function resetNewListBooleans(accountId) {
  const actionText = 'Reseting booleans';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(resetBooleans());
    completeAction(dispatch, actionText);
    dispatch(push(`/data/newList/${accountId}`));
  };
}

// Action - Create New SKUs
const syncFieldsSuccess = (syncedFields, datasetId) => ({
  type: actionTypes.FIELD_SYNC_SUCCESS,
  syncedFields,
  datasetId,
});

const createNewFieldsetSuccess = skuInfo => ({
  type: actionTypes.NEW_SKU_SUCCESS,
  skuInfo,
});

export function createNewFieldset(datasetId, fieldsetFields, fieldsetName, fieldsetType, token) {
  const actionText = 'Creating new Fieldset';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(async client => {
      try {
        // add fieldset
        const addFieldSetResponse = await client.datasets.addFieldSet({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          body: {
            name: fieldsetName,
            setType: fieldsetType,
          },
        });
        const SKUInfo = addFieldSetResponse.obj;
        const skuId = SKUInfo.id;
        const formattedData = fieldsetFields.map(listItem => {
          const listObj = {
            fieldsetId: skuId,
            fieldId: parseInt(listItem, 10),
            ordering: 0,
          };
          return listObj;
        });
        dispatch(createNewFieldsetSuccess(SKUInfo));
        completeAction(dispatch, 'Added Fieldset');

        // sync fieldset fields
        const syncFieldSetFieldsResponse = await client.datasets.syncFieldSetFields({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: skuId,
          body: JSON.stringify(formattedData),
        });
        const fieldInfo = syncFieldSetFieldsResponse.obj;
        let successMessage = '';
        if (fieldsetType === FIELDSET_TYPE_SKU) successMessage = 'New SKU Created';
        else successMessage = 'New Group Created';
        dispatch(syncFieldsSuccess(fieldInfo, datasetId));
        dispatch(push(`/data/dataset/${datasetId}`));
        reportSuccess(dispatch, successMessage, null);
        completeAction(dispatch, actionText);
      } catch (err) {
        handleError(err, dispatch, actionText);
      }
    });
  };
}

export function updateFieldSetFields(
  fieldsetId,
  datasetId,
  currentFieldsetFields,
  newFieldsetFields,
  fieldsetType,
  isAdminPage,
  token
) {
  const actionText = 'Updating Fieldset';
  return dispatch => {
    startAction(dispatch, actionText);
    let formattedCurrentFields = new Map();
    currentFieldsetFields.map(field => {
      formattedCurrentFields = formattedCurrentFields.set(field.fieldId, field.id);
      return field;
    });
    const formattedData = newFieldsetFields.map(field => {
      // If the field was already in the fieldset, we must keep it's unique id
      const fieldsetFieldId = formattedCurrentFields.get(parseInt(field, 10)) || null;
      return {
        id: fieldsetFieldId,
        fieldsetId,
        fieldId: parseInt(field, 10),
        ordering: 0,
      };
    });
    return swaggerApi.then(client => {
      client.datasets
        .syncFieldSetFields({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: fieldsetId,
          body: JSON.stringify(formattedData),
        })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            const fieldInfo = response.obj;
            const pageProgression = isAdminPage
              ? '/superadmin/listsummary'
              : `/data/dataset/${datasetId}`;
            dispatch(syncFieldsSuccess(fieldInfo, datasetId));
            dispatch(push(pageProgression));
            let successMessage = '';
            if (fieldsetType === FIELDSET_TYPE_SKU) successMessage = 'SKU Updated';
            else successMessage = 'Group Updated';
            reportSuccess(dispatch, successMessage, null);
            completeAction(dispatch, actionText);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

export function updateSku(skuId, datasetId, inSkuMap, newToSkuMap, SKUName, isAdminPage, token) {
  const actionText = 'Updating SKU';
  return dispatch => {
    startAction(dispatch, actionText);
    const list1 = newToSkuMap.toList();
    const formattedData1 = list1.map(listItem => {
      const listObj = {
        fieldsetId: skuId,
        fieldId: listItem.id,
        ordering: 0,
      };
      return listObj;
    });
    const list2 = inSkuMap.toList();
    const formattedData2 = list2.map(listItem => {
      const listObj = {
        id: listItem.skuId,
        fieldsetId: skuId,
        fieldId: listItem.id,
        ordering: 0,
      };
      return listObj;
    });
    const formattedData = formattedData2.concat(formattedData1);
    return swaggerApi.then(client => {
      client.datasets
        .syncFieldSetFields({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: skuId,
          body: JSON.stringify(formattedData),
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const fieldInfo = response.obj;
            const pageProgression = isAdminPage ? '/superadmin/listsummary' : '/data';
            dispatch(syncFieldsSuccess(fieldInfo, datasetId));
            reportSuccess(dispatch, 'SKU Uploaded', null);
            completeAction(dispatch, actionText);
            dispatch(push(pageProgression));
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

export function updateSkuProps(token, datasetId, skuInfo) {
  const actionText = 'Updating SKU props';
  return dispatch => {
    startAction(dispatch, actionText);
    const newSkuInfo = {
      name: skuInfo.name,
      setType: skuInfo.setType,
      status: skuInfo.status,
    };
    return swaggerApi.then(client => {
      client.datasets
        .updateFieldSet({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: skuInfo.id,
          body: JSON.stringify(newSkuInfo),
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const skuDeleteSuccess = fieldsetInfo => ({
  type: actionTypes.DELETE_SKU,
  fieldsetInfo,
});

export function deleteSku(token, skuId, datasetId, fieldsetType, isAdminPage, resolve) {
  const actionText = 'deleting sku';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .deleteFieldSet({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: skuId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const fieldsetInfo = response.obj;
            const pageProgression = isAdminPage
              ? '/superadmin/listsummary'
              : `/data/dataset/${datasetId}`;
            dispatch(skuDeleteSuccess(fieldsetInfo));
            completeAction(dispatch, actionText);
            dispatch(push(pageProgression));
            let successMessage = '';
            if (fieldsetType === FIELDSET_TYPE_SKU) successMessage = 'SKU Deleted';
            else successMessage = 'Group Deleted';
            reportSuccess(dispatch, successMessage, null);
            resolve();
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const openEditListSuccess = (datasetId, admin) => ({
  type: actionTypes.OPEN_EDIT_LIST,
  datasetId,
  admin,
});

export function openEditList(datasetId, admin) {
  const actionText = 'passing info to open the edit list page';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(openEditListSuccess(datasetId, admin));
    completeAction(dispatch, actionText);
    dispatch(push('/editList'));
  };
}

const openConfigFormSuccess = (platformCode, datasetId) => ({
  type: actionTypes.OPEN_CONFIG_FORM,
  platformCode,
  datasetId,
});

export function openConfigForm(platformCode, datasetId) {
  const actionText = 'passing info to open the configure platform page';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(openConfigFormSuccess(platformCode, datasetId));
    completeAction(dispatch, actionText);
    dispatch(push('/superadmin/configurePlatform'));
  };
}

// More concise syntax
const fetchFilesetsSuccess = filesets => ({
  type: actionTypes.FETCH_FILESET_SUCCESS,
  filesets,
});

export function fetchFilesets(datasetId, token) {
  const actionText = 'fetching filesets';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFileSets({
          dataset_id: datasetId,
          Authorization: `bearer ${token}`,
        })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            dispatch(fetchFilesetsSuccess(response.obj));
            completeAction(dispatch, actionText);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const openFilesetPreviewSuccess = (dataset, filesetInfo) => ({
  type: actionTypes.OPEN_FILESET_PREVIEW,
  dataset,
  filesetInfo,
});

export function openFilesetPreview(token, dataset) {
  const actionText = 'passing info to open the fileset preview page';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFileSets({
          Authorization: `bearer ${token}`,
          dataset_id: dataset.id,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const filesetInfo = response.obj;
            dispatch(openFilesetPreviewSuccess(dataset, filesetInfo));
            completeAction(dispatch, actionText);
            dispatch(push(`/data/filesetPreview/${dataset.id}`));
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const fetchFilesetPreviewSuccess = (filesetId, filesetPreviewInfo) => ({
  type: actionTypes.FETCH_FILESET_PREVIEW,
  filesetId,
  filesetPreviewInfo,
});

export function fetchFilesetPreviewById(token, datasetId, filesetId, versionId) {
  const actionText = 'fetching fileset preview id';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getDataSetPreview({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fileset_id: filesetId,
          version: versionId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const filesetPreviewInfo = response.obj;
            dispatch(fetchFilesetPreviewSuccess(filesetId, filesetPreviewInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const enableVersionSuccess = versionInfo => ({
  type: actionTypes.ENABLE_VERSION,
  versionInfo,
});

export function enableDatasetVersion(token, datasetId, versionId, resolve) {
  const actionText = 'setting dataset version to active';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .setActiveVersion({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          body: {
            id: versionId,
            datasetId,
            version: versionId,
            status: 1,
          },
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const versionInfo = response.obj;
            dispatch(enableVersionSuccess(versionInfo));
            completeAction(dispatch, actionText);
            resolve();
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

export function deleteDatasetVersion(token, datasetId, versionId, resolve) {
  const actionText = 'delete dataset version';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .deleteDataSetVersion({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          version_id: versionId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            completeAction(dispatch, actionText);
            resolve();
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Cancel adding or editing a sku or group
export function cancelGroupSKU(datasetId) {
  return dispatch => {
    dispatch(push(`/data/dataset/${datasetId}`));
  };
}

const openSkuCreationSuccess = (datasetId, datasetName) => ({
  type: actionTypes.OPEN_SKU_CREATION,
  datasetId,
  datasetName,
});

export function openSkuCreation(datasetId, datasetName) {
  const actionText = 'passing info to open the SKU creation form';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(openSkuCreationSuccess(datasetId, datasetName));
    completeAction(dispatch, actionText);
    dispatch(push(`/data/dataset/${datasetId}/${NEW_SKU_PAGE}`));
  };
}

const openGroupCreationSuccess = (datasetId, datasetName) => ({
  type: actionTypes.OPEN_GROUP_CREATION,
  datasetId,
  datasetName,
});

export function openGroupCreation(datasetId, datasetName) {
  const actionText = 'passing info to open the Group creation form';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(openGroupCreationSuccess(datasetId, datasetName));
    completeAction(dispatch, actionText);
    dispatch(push(`/data/dataset/${datasetId}/${NEW_GROUP_PAGE}`));
  };
}

const openEditSkuSuccess = (skuFields, fieldsetId, datasetId, datasetName, isAdminPage) => ({
  type: actionTypes.OPEN_EDIT_SKU,
  skuFields,
  fieldsetId,
  datasetId,
  datasetName,
  isAdminPage,
});

export function openEditSku(token, fieldsetId, datasetId, datasetName, isAdminPage) {
  const actionText = 'passing info to open the SKU/Group edit form';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFieldSetFields({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: fieldsetId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const skuFields = response.obj;
            dispatch(
              openEditSkuSuccess(skuFields, fieldsetId, datasetId, datasetName, isAdminPage)
            );
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          dispatch(push('/data'));
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Go to edit page
export function goToEditFieldset(fieldsetId, datasetId, page) {
  const actionText = 'Going to SKU/Group edit page';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(push(`/data/dataset/${datasetId}/${page}/${fieldsetId}`));
    completeAction(dispatch, actionText);
  };
}

const fetchGroupFieldsSuccess = groupFields => ({
  type: actionTypes.FETCH_GROUP_FIELDS_SUCCESS,
  groupFields,
});

export function fetchGroupFieldsById(datasetId, groupId, resolve, token) {
  const actionText = 'fetching group fields';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFieldSetFields({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: groupId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const groupFields = response.obj;
            dispatch(fetchGroupFieldsSuccess(groupFields));
            completeAction(dispatch, actionText);
            resolve();
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const clearFieldsForSkuSuccess = () => ({
  type: actionTypes.CLEAR_FIELDS_FOR_SKU,
});

export function clearFieldsForSku(resolve) {
  const actionText = 'clearingSkuFields';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(clearFieldsForSkuSuccess());
    completeAction(dispatch, actionText);
    resolve();
  };
}

const getFieldsForSkuSuccess = skuFields => ({
  type: actionTypes.GET_FIELDS_FOR_SKU,
  skuFields,
});

export function getFieldsForSku(token, skuId, datasetId) {
  const actionText = 'getting fields for SKU';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.datasets
        .getFieldSetFields({
          Authorization: `bearer ${token}`,
          dataset_id: datasetId,
          fieldset_id: skuId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const skuFields = response.obj;
            dispatch(getFieldsForSkuSuccess(skuFields));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const setCurrentDatasetSuccess = datasetId => ({
  type: actionTypes.SET_CURRENT_DATASET,
  datasetId,
});

export function setCurrentDataset(datasetId) {
  const actionText = 'setting current version of dataset';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(setCurrentDatasetSuccess(datasetId));
    completeAction(dispatch, actionText);
  };
}

const checkAllDragTableRowStateSuccess = (newMap, value) => ({
  type: actionTypes.CHECK_ALL_DRAG_TABLE_ROW_STATE,
  newMap,
  value,
});

export function checkAllDragTableRowState(newMap, value) {
  const actionText = 'initializing rowState';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(checkAllDragTableRowStateSuccess(newMap, value));
    completeAction(dispatch, actionText);
  };
}

const updateDragTableRowStateSuccess = (id, value) => ({
  type: actionTypes.UPDATE_DRAG_TABLE_ROW_STATE,
  id,
  value,
});

export function updateDragTableRowState(id, value) {
  const actionText = 'updated rowState';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(updateDragTableRowStateSuccess(id, value));
    completeAction(dispatch, actionText);
  };
}

const updateDragTableCheckedSuccess = newMap => ({
  type: actionTypes.UPDATE_DRAG_TABLE_CHECKED,
  newMap,
});

export function updateDragTableChecked(newMap) {
  const actionText = 'adding field to dragTableChecked';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(updateDragTableCheckedSuccess(newMap));
    completeAction(dispatch, actionText);
  };
}

const updateDropTableCompleteSuccess = newMap => ({
  type: actionTypes.UPDATE_DROP_TABLE_COMPLETE,
  newMap,
});

export function updateDropTableComplete(newMap) {
  const actionText = 'updated dropTableComplete';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(updateDropTableCompleteSuccess(newMap));
    completeAction(dispatch, actionText);
  };
}

const updateDropTableCheckedSuccess = newMap => ({
  type: actionTypes.UPDATE_DROP_TABLE_CHECKED,
  newMap,
});

export function updateDropTableChecked(newMap) {
  const actionText = 'updating dropTableChecked';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(updateDropTableCheckedSuccess(newMap));
    completeAction(dispatch, actionText);
  };
}

const checkAllDropTableRowStateSuccess = (newMap, value) => ({
  type: actionTypes.CHECK_ALL_DROP_TABLE_ROW_STATE,
  newMap,
  value,
});

export function checkAllDropTableRowState(newMap, value) {
  const actionText = 'initializing rowState';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(checkAllDropTableRowStateSuccess(newMap, value));
    completeAction(dispatch, actionText);
  };
}

const updateDropTableRowStateSuccess = (id, value) => ({
  type: actionTypes.UPDATE_DROP_TABLE_ROW_STATE,
  id,
  value,
});

export function updateDropTableRowState(id, value) {
  const actionText = 'updated rowState';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(updateDropTableRowStateSuccess(id, value));
    completeAction(dispatch, actionText);
  };
}

const updateDragTableCompleteSuccess = newMap => ({
  type: actionTypes.UPDATE_DRAG_TABLE_COMPLETE,
  newMap,
});

export function updateDragTableComplete(newMap) {
  const actionText = 'updating dragTableComplete';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(updateDragTableCompleteSuccess(newMap));
    completeAction(dispatch, actionText);
  };
}

export function openDatasetReportsPage(datasetId) {
  const actionText = 'Opening Dataset Reports Page;';
  return dispatch => {
    startAction(dispatch, actionText);
    dispatch(push(`/data/reports/${datasetId}`));
    completeAction(dispatch, actionText);
  };
}
